module.exports = __webpack_public_path__ + "static/career-food-60dc77051cadf1cb8e1b774aa431d289.png";